import { render, staticRenderFns } from "./affiliates-base.view.vue?vue&type=template&id=231927ce&scoped=true&"
import script from "./affiliates-base.view.vue?vue&type=script&lang=ts&"
export * from "./affiliates-base.view.vue?vue&type=script&lang=ts&"
import style0 from "./affiliates-base.view.vue?vue&type=style&index=0&id=231927ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231927ce",
  null
  
)

export default component.exports